import React from 'react';
import type { RouteObject } from 'react-router-dom';

import { JourneyVariant } from '@r6digital/rapidstor-types/react/entities/Journey';
import Logger from '@/core/utils/logging';
import Error from '@/journey-based-listing/screens/error';

import { buildJblRoutes } from './jbl';
import { buildStandardUnitListingRoutes } from './standardUnitListing';

export function buildJourneyRoutes(): RouteObject[] {
    if (!window.rapidstor_settings.app_config) {
        Logger.error(`App config not found: ${window.location}`);
        return [{ path: '', element: <Error /> }];
    }

    const { variant } = window.rapidstor_settings.app_config.journey;
    if (variant === JourneyVariant.STANDARD_UNIT_LISTING) {
        return buildStandardUnitListingRoutes();
    }
    // Default to JBL variant.
    return buildJblRoutes();
}
